import React from 'react';
import { StyledHeaderDirectory, StyledHeaderItem } from './style';

const HeaderData = [
  'Visto',
  'Fecha',
  // 'Tipo de Notificación',
  'Tipo de Contenido',
  'Título'
];

const HeaderNotificationList = () => (
  <StyledHeaderDirectory>
    {HeaderData.map((item, i) => (
      <StyledHeaderItem key={`header-g-${i + 1}`}>{item}</StyledHeaderItem>
    ))}
  </StyledHeaderDirectory>
);

export default HeaderNotificationList;
